/* eslint-disable deprecation/deprecation */
import React, { useMemo } from 'react';
import { UIComponentsProvider } from '@lumahealthhq/ui-components';
import { EThemeKey, createLogger, getThemeOptions } from '../utils';
import ModulesContext from './ModulesContext';
import SnackbarContextProvider from './SnackbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIModulesProvider(_ref) {
  var children = _ref.children,
    navigate = _ref.navigate,
    navigateBack = _ref.navigateBack,
    onOpen = _ref.onOpen,
    productsMap = _ref.productsMap,
    routingMap = _ref.routingMap,
    switchAccount = _ref.switchAccount,
    updateToken = _ref.updateToken,
    messages = _ref.messages,
    onMessage = _ref.onMessage,
    mixed = _ref.mixed,
    themeOptionsProp = _ref.themeOptions,
    env = _ref.env,
    keyEnv = _ref.keyEnv,
    keyAuthToken = _ref.keyAuthToken,
    loggerProp = _ref.logger,
    config = _ref.config,
    locale = _ref.locale,
    setLocale = _ref.setLocale,
    axiosClient = _ref.axiosClient;
  var contextValue = useMemo(function () {
    return {
      routingMap: routingMap,
      productsMap: productsMap,
      navigate: navigate,
      navigateBack: navigateBack,
      switchAccount: switchAccount,
      updateToken: updateToken
    };
  }, [routingMap, productsMap, navigate, navigateBack, switchAccount, updateToken]);
  var themeOptions = useMemo(function () {
    return themeOptionsProp || getThemeOptions(EThemeKey.Base);
  }, [themeOptionsProp]);
  var logger = useMemo(function () {
    return loggerProp || createLogger();
  }, [loggerProp]);
  return /*#__PURE__*/_jsx(ModulesContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(UIComponentsProvider
    // UIComponents
    , {
      messages: messages,
      onMessage: onMessage,
      mixed: mixed
      // UICore
      ,
      themeOptions: themeOptions
      // UIModel
      ,
      env: env,
      keyEnv: keyEnv,
      keyAuthToken: keyAuthToken
      // UIUtils
      ,
      logger: logger,
      config: config,
      locale: locale,
      setLocale: setLocale,
      axiosClient: axiosClient,
      children: /*#__PURE__*/_jsx(SnackbarContextProvider, {
        onOpen: onOpen,
        children: children
      })
    })
  });
}